// extracted by mini-css-extract-plugin
export var footer = "Footer_footer__G5beA";
export var footerBottom = "Footer_footer_bottom__42v80";
export var footerInner = "Footer_footer_inner__j3Ck7";
export var footerNav = "Footer_footer_nav__nIWUy";
export var footerNavItem = "Footer_footer_nav_item__EHRTb";
export var footerNavLink = "Footer_footer_nav_link__ugbow";